// extracted by mini-css-extract-plugin
export default {"leftHeader":"LeftSkewHeader_leftHeader__JSoAn"};